import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserState } from '../state/user/user.state';

export function isBackendRequestUrl(url: string): boolean {
  try {
    const browserOrigin = window.location.origin;
    const backendUrl = new URL(environment.baseUrl, browserOrigin);
    const requestUrl = new URL(url, browserOrigin);
    const backendPath = backendUrl.pathname.replace(/\/+$/, '');

    return (
      requestUrl.origin === backendUrl.origin &&
      (!backendPath ||
        requestUrl.pathname === backendPath ||
        requestUrl.pathname.startsWith(`${backendPath}/`))
    );
  } catch {
    return false;
  }
}

function isPublicAdminAuthRequestUrl(url: string): boolean {
  try {
    const browserOrigin = window.location.origin;
    const backendUrl = new URL(environment.baseUrl, browserOrigin);
    const requestUrl = new URL(url, browserOrigin);
    const backendPath = backendUrl.pathname.replace(/\/+$/, '');
    const relativePath = requestUrl.pathname.slice(backendPath.length);

    return [
      '/admin/auth/login',
      '/admin/auth/send-password-reset-code',
      '/admin/auth/reset-password',
    ].includes(relativePath);
  } catch {
    return false;
  }
}

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(private readonly store: Store) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.Token;

    if (
      !token ||
      !isBackendRequestUrl(request.url) ||
      isPublicAdminAuthRequestUrl(request.url)
    ) {
      return next.handle(request);
    }

    const tokenizedRequest = request.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });

    return next.handle(tokenizedRequest);
  }

  get Token(): string | undefined {
    return this.store.selectSnapshot(UserState.token);
  }
}
